import React, { Component } from 'react';
import { Row, Col, Modal,Button } from 'antd';
import PropTypes from "prop-types";
import Scrollbars from 'react-custom-scrollbars';
import {uuid, getSubffix, applicationName} from "../../../utils";
import UploadWall from '../../../components/upload/UploadWall';
import ChunkUpload from '../../../components/upload/ChunkUpload';
import { FILE_TYPE } from '../../../constants';

const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class ClueLook extends Component {
    static defaultProps = {}
    static propTypes = {
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        submitTime: PropTypes.string.isRequired,
        status: PropTypes.number.isRequired,
        isinterview: PropTypes.number.isRequired,
        contacts: PropTypes.string.isRequired,
        content: PropTypes.string,
        submitter: PropTypes.string.isRequired,
        review_content: PropTypes.string.isRequired,
        clueId: PropTypes.object.isRequired,
        pictureData: PropTypes.array.isRequired,
        videoData: PropTypes.array.isRequired,
        attachmentFileData: PropTypes.array.isRequired,
    }
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            previewVisible:false,
            fileType:2,
            previewImage:false
        }
    }
    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    
    //预览
    handlePreview = async file => {
        if (file.fileType === 3){//代表是视频
            file.url = file.path
        }else{
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
        }
        console.log("url:    ", file.url || file.preview);
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            fileType: file.fileType
        });
    };

    render() {
        const status = this.props.status
        const isinterview = this.props.isinterview
        let statusContent
        let statusOperation
        if (status === 0) {
            statusContent = (
                <span>已提交</span>
            )
        } else if (status === 1 && isinterview === 1) {
            statusContent = (
                <span>转为任务</span>
            )

        } else if (status === 1) {
            statusContent = (
                <span>
                    已采用
                </span>
            )
        } else if (status === 2) {
            statusContent = (
                <span>
                    已弃用
                </span>
            )
        }

        // 操作
        if (status === 0) {
            statusOperation = (
                <div>
                    <span style={{ margin: "0px 5px" }}>
                        <Button size="small" type="primary" onClick={this.props.adopt} style={{backgroundColor:this.props.newSecondSelectColor,borderColor:this.props.newSecondSelectColor}}>采用</Button>
                    </span>
                    <Button size="small" type="primary" onClick={this.props.abandon} style={{backgroundColor:this.props.newSecondSelectColor,borderColor:this.props.newSecondSelectColor}}>弃用</Button>
                </div>
            )
        }
        else if (status === 1 && isinterview !== 1 && this.props.currentUser.roleCodes.indexOf("xsbj") === -1) {   //判断是否有管理权限
            statusOperation = (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ marginLeft: "5px" }}>
                        <Button size="small" type="primary" onClick={() => this.props.newsClueAdd()} style={{backgroundColor:this.props.newSecondSelectColor,borderColor:this.props.newSecondSelectColor}}>转为任务</Button>
                    </div>
                </div>
            )
        }
        else if (status === 1 && isinterview === 1) {
            statusOperation = (
                <div style={{ marginLeft: "5px" }}>
                    <Button size="small" onClick={() => this.props.newsClueView()}>查看任务</Button>
                </div>
            )
        }
        return (
            <div>
                <Modal
                    title="线索详情"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width="1050px"
                    zIndex={500}
                    bodyStyle={{height:"600px"}}
                    footer={<div>
                        {statusOperation}
                    </div>}
                >
            <Scrollbars>
                <div style={{height:"500px"}}>
                    <div style={{ padding: "15px" }}>
                        <Row justify="start">
                            {/* 全选 */}
                            <Col span={8}>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>线索状态</div>
                                <div style={{
                                    color: "#808eb5", fontSize: "14px", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}>{statusContent}</div>
                            </Col>
                            <Col span={16}>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>审核意见</div>
                                <div title={this.props.review_content} style={{
                                    color: "#808eb5", fontSize: "14px", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap", lineClamp: 2
                                }}>{this.props.review_content}</div>
                            </Col>

                        </Row>
                    </div>
                    <div
                        style={{ padding: "15px" }}
                    >
                        <Row justify="start">
                            {/* 全选 */}
                            <Col span={8}>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>提交人</div>
                                <div style={{
                                    color: "#808eb5", fontSize: "14px", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}>{this.props.clueId.submitterName}</div>
                            </Col>
                            <Col span={16}>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>线索标题</div>
                                <div title={this.props.title} style={{
                                    color: "#808eb5", fontSize: "14px", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap", lineClamp: 2
                                }}>{this.props.title}</div>
                            </Col>

                        </Row>
                    </div>
                    <div
                        style={{ padding: "15px" }}
                    >
                        <Row justify="start">
                            {/* 全选 */}
                            <Col span={8}>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>联系电话</div>
                                <div style={{
                                    color: "#808eb5", fontSize: "14px", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}>{this.props.contactsWay}</div>
                            </Col>
                            <Col span={8}>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>操作时间</div>
                                <div style={{ color: "#808eb5", fontSize: "14px" }}>{this.props.submitTime}</div>
                            </Col>
                            <Col span={8}>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>联系人</div>
                                <div style={{ color: "#808eb5", fontSize: "14px" }}>{this.props.contacts}</div>
                            </Col>
                        </Row>
                    </div>
                    <div
                        style={{ padding: "15px" }}
                    >
                        <Row justify="start">
                            {/* 全选 */}

                            <Col span={24}>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>线索内容</div>
                                <div title={this.props.clueId.content} style={{
                                    color: "#808eb5", fontSize: "14px",

                                }}>{this.props.clueId.content}</div>
                            </Col>

                        </Row>
                    </div>
                    <div
                        style={{ padding: "15px" }}
                    >
                        <Row justify="start">
                            {/* 全选 */}
                            <Col span={8}>
                                <div>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>线索图片</div>
                                    <div style={{ display:"flex",flexWrap:"wrap"}}>
                                        <UploadWall
                                            accept={"."+[...FILE_TYPE].join(",.")}
                                            multiple={true}
                                            action={"/cm-sites-" + applicationName() + "/index/uploadFile"}
                                            listType="picture-card"
                                            fileList={(()=>{
                                                let fileList = [];
                                                this.props.pictureData && this.props.pictureData.map(attachment=>{
                                                    fileList.push({
                                                        uid: uuid(),
                                                        ...attachment,
                                                        status: 'done',
                                                        path : attachment.path,
                                                        url : attachment.path,
                                                        ext: getSubffix(attachment.name),
                                                        fileType: 2
                                                    })
                                                });
                                                console.log("fileList:   ", fileList);
                                                return fileList;
                                            })()}
                                            customRequest={new ChunkUpload({
                                                checkFileURL:"/cm-sites-"+applicationName()+"/index/checkFile",
                                                checkChunkURL:"/cm-sites-"+applicationName()+"/index/checkChunk",
                                                uploadChunkURL:"/cm-sites-"+applicationName()+"/index/uploadChunks",
                                                chunkUploadOverURL:"/cm-sites-"+applicationName()+"/index/chunkUploadOver",
                                                mergeChunksURL:"/cm-sites-"+applicationName()+"/index/mergeChunks"
                                            }).start}
                                            icons={(()=>{
                                                let res = ["eye", "download"];
                                                return res;
                                            })()}
                                            onPreview={this.handlePreview}
                                            uploadBtnName={""}
                                            showUploadBtn={ false}
                                            onDownload={(file)=>{
                                                if(file.path.indexOf("?") === -1){
                                                    window.location.href = file.path + "?download=1";
                                                }else{
                                                    window.location.href = file.path + "&download=1";
                                                }
                                            }}
                                            style={{padding:"0px"}}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>线索视频</div>                                
                                    <UploadWall
                                            accept={"."+[...FILE_TYPE].join(",.")}
                                            multiple={true}
                                            action={"/cm-sites-" + applicationName() + "/index/uploadFile"}
                                            listType="picture-card"
                                            fileList={(()=>{
                                                let fileList = [];
                                                this.props.videoData && this.props.videoData.map(attachment=>{
                                                    fileList.push({
                                                        uid: uuid(),
                                                        ...attachment,
                                                        status: 'done',
                                                        path : attachment.path,
                                                        url : attachment.path,
                                                        ext: getSubffix(attachment.name),
                                                        fileType: 3
                                                    })
                                                });
                                                console.log("fileList:   ", fileList);
                                                return fileList;
                                            })()}
                                            customRequest={new ChunkUpload({
                                                checkFileURL:"/cm-sites-"+applicationName()+"/index/checkFile",
                                                checkChunkURL:"/cm-sites-"+applicationName()+"/index/checkChunk",
                                                uploadChunkURL:"/cm-sites-"+applicationName()+"/index/uploadChunks",
                                                chunkUploadOverURL:"/cm-sites-"+applicationName()+"/index/chunkUploadOver",
                                                mergeChunksURL:"/cm-sites-"+applicationName()+"/index/mergeChunks"
                                            }).start}
                                            icons={(()=>{
                                                let res = ["play", "download"];
                                                return res;
                                            })()}
                                            onPlay={this.handlePreview}
                                            uploadBtnName={""}
                                            showUploadBtn={ false}
                                            onDownload={(file)=>{
                                                if(file.path.indexOf("?") === -1){
                                                    window.location.href = file.path + "?download=1";
                                                }else{
                                                    window.location.href = file.path + "&download=1";
                                                }
                                            }}
                                            style={{padding:"0px"}}
                                        />
                                </div>
                            </Col>
                            <Col span={8}>
                                <div>
                                <div style={{ marginBottom: "16px", color: "rgb(108, 116, 139)", fontWeight: "bold", fontSize: "14px" }}>线索附件</div>
                                <UploadWall
                                            accept={"."+[...FILE_TYPE].join(",.")}
                                            multiple={true}
                                            action={"/cm-sites-" + applicationName() + "/index/uploadFile"}
                                            listType="picture-card"
                                            fileList={(()=>{
                                                let fileList = [];
                                                this.props.attachmentFileData && this.props.attachmentFileData.map(attachment=>{
                                                    fileList.push({
                                                        uid: uuid(),
                                                        ...attachment,
                                                        status: 'done',
                                                        path : attachment.path,
                                                        url : attachment.path,
                                                        ext: getSubffix(attachment.name),
                                                        // fileType: 3
                                                    })
                                                });
                                                return fileList;
                                            })()}
                                            customRequest={new ChunkUpload({
                                                checkFileURL:"/cm-sites-"+applicationName()+"/index/checkFile",
                                                checkChunkURL:"/cm-sites-"+applicationName()+"/index/checkChunk",
                                                uploadChunkURL:"/cm-sites-"+applicationName()+"/index/uploadChunks",
                                                chunkUploadOverURL:"/cm-sites-"+applicationName()+"/index/chunkUploadOver",
                                                mergeChunksURL:"/cm-sites-"+applicationName()+"/index/mergeChunks"
                                            }).start}
                                            icons={(()=>{
                                                let res = ["download"];
                                                return res;
                                            })()}
                                            uploadBtnName={""}
                                            showUploadBtn={ false}
                                            onDownload={(file)=>{
                                                if(file.path.indexOf("?") === -1){
                                                    window.location.href = file.path + "?download=1";
                                                }else{
                                                    window.location.href = file.path + "&download=1";
                                                }
                                            }}
                                            style={{padding:"0px"}}
                                        />                                  
                                </div>
                            </Col>
                            
                        </Row>
                    </div>
                </div>
                    
                    </Scrollbars>
                    
                </Modal>
                {(()=>{
                    let {previewVisible, fileType, previewImage} = this.state;
                    return <Modal
                        visible={previewVisible}
                        footer={null}
                        onCancel={() => this.setState({ previewVisible: false })}>
                        {
                            fileType === 2 ? <img alt="example" style={{ width: '100%' }} src={previewImage} /> : <video controls={"controls"} style={{ width: '100%' }} src={previewImage} />
                        }
                    </Modal>
                })()}
            </div>
        );
    }
    downFile(path){
        window.location=path+'?download=1';
    }
}

export default ClueLook;